import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { ProtectedRoute } from "@/components/Guards";
import Navbar from "@/components/Navbar";
import Landing from "@/pages/Landing";
import { Login, Register } from "@/pages/Auth";
import AuthCallback from "@/pages/AuthCallback";
import Onboarding from "@/pages/Onboarding";
import Discover from "@/pages/Discover";
import MemberProfile from "@/pages/MemberProfile";
import Messages from "@/pages/Messages";
import Membership from "@/pages/Membership";
import Tokens from "@/pages/Tokens";
import Cams from "@/pages/Cams";
import CamRoom from "@/pages/CamRoom";
import Market from "@/pages/Market";
import WalletPage from "@/pages/Wallet";
import Verify from "@/pages/Verify";
import MyProfile from "@/pages/MyProfile";
import Admin from "@/pages/Admin";
import { PaymentSuccess, PaymentCancel } from "@/pages/Payment";

const P = (el, admin) => <ProtectedRoute admin={admin}>{el}</ProtectedRoute>;

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <>
      <Navbar />
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/onboarding" element={P(<Onboarding />)} />
        <Route path="/discover" element={P(<Discover />)} />
        <Route path="/members/:id" element={P(<MemberProfile />)} />
        <Route path="/messages" element={P(<Messages />)} />
        <Route path="/messages/:id" element={P(<Messages />)} />
        <Route path="/membership" element={P(<Membership />)} />
        <Route path="/tokens" element={P(<Tokens />)} />
        <Route path="/cams" element={P(<Cams />)} />
        <Route path="/cams/:id" element={P(<CamRoom />)} />
        <Route path="/market" element={P(<Market />)} />
        <Route path="/wallet" element={P(<WalletPage />)} />
        <Route path="/verify" element={P(<Verify />)} />
        <Route path="/me" element={P(<MyProfile />)} />
        <Route path="/admin" element={P(<Admin />, true)} />
        <Route path="/payment/success" element={P(<PaymentSuccess />)} />
        <Route path="/payment/cancel" element={P(<PaymentCancel />)} />
      </Routes>
    </>
  );
}

export default function App() {
  return (
    <div className="App dark">
      <BrowserRouter>
        <AuthProvider>
          <AppRouter />
          <Toaster theme="dark" position="top-right" />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}
